import type { RegularOrders } from '../../types/RegularOrders';

export const regularOrdersBaseFeatureConfig: RegularOrders = {
    frequencyReadOnly: false,
    note: false,
    validFrom: false,
    validUntil: false,
    postponedUntil: false,
    showNewOrderButtonInEmbeddedLayout: true,
};
